import reducer from "./reducers";

import * as conceptsAction from "./actions";

export { conceptsAction };

export default reducer;
